<template>
  <div class="b-apply-wrap">
    <div class="b-apply-card">
      <h2>选择入驻类型</h2>
      <p class="sub">统一 B 端大门 · 请选择要开通的经营台</p>
      <div class="catalog">
        <div v-for="item in catalog" :key="item.consoleId" class="catalog-item" @click="go(item)">
          <div class="title">{{ item.apply.title }}</div>
          <div class="desc">{{ item.description }}</div>
        </div>
      </div>
      <el-button class="mt-16px" link type="primary" @click="$router.push('/store/login')">
        已有账号？去登录
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { listApplyCatalog, type ConsoleDescriptor } from '@/views/merchant/registry/consoles'

defineOptions({ name: 'MerchantBApplyCatalog' })

const router = useRouter()
const catalog = computed(() => listApplyCatalog())

function go(item: ConsoleDescriptor) {
  if (item.consoleId === 'MALL_SHOP') {
    ElMessage.info('商城商家请在 C 端 App「商家入驻」提交申请；审核通过后使用本工作台登录。')
    return
  }
  router.push(item.apply.path)
}
</script>

<style scoped lang="scss">
.b-apply-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  padding: 24px;
}
.b-apply-card {
  width: 560px;
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  h2 {
    margin: 0 0 8px;
    font-size: 22px;
  }
  .sub {
    color: #909399;
    margin: 0 0 24px;
    font-size: 14px;
  }
}
.catalog-item {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  cursor: pointer;
  &:hover {
    border-color: #409eff;
    background: #f0f9ff;
  }
  .title {
    font-weight: 600;
    margin-bottom: 6px;
  }
  .desc {
    font-size: 13px;
    color: #909399;
  }
}
</style>
